import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxPostComponent } from './mx.post.component';
import { MxPipesModule } from '../../pipes/mx.pipes.module';

export const COMPONENTS: any[] = [MxPostComponent];

@NgModule({
  imports: [CommonModule, RouterModule, PrimengModule, MxPipesModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxPostModule { }
